import { useCallback, useEffect, useRef, useState } from "react";

import { getJson, payOrder, postJson } from "./money";
import { btn, C, fill, FONT, label } from "./publicShared";

// Talk to a real astrologer — 15-minute paid chat (₹199, paid upfront).
// Honest by design: we say plainly how long a reply may take, that a refund
// is available if nobody joins, and that phone numbers are hidden in chat.

const T = {
  en: {
    title: "Talk to an astrologer",
    sub: "Ask your question to a real, verified Vedic astrologer. They see your birth chart, so you don't have to explain it.",
    how: ["Write your question", "Pay {p} once (UPI, card)", "An astrologer joins and chats with you for {m} minutes"],
    promise: "Our astrologers promise: no fear, no guaranteed predictions, no pushing gemstones or costly pujas.",
    none: "Our first astrologers are joining now. Please check again in a few days.",
    joinAstro: "Are you an astrologer? Join VedSanga",
    online: "Online now", years: "{n} years experience", langs: "Speaks",
    ask: "Ask {n}", askAny: "Ask the first available astrologer",
    qLabel: "Your question", qHelp: "Write it the way you would say it to a family pandit. Example: My marriage is getting delayed — when is a good time?",
    noBirth: "Your birth details are not saved yet. Add them in Jyotish first, so the astrologer can read your chart.",
    pay: "Pay {p} and send question", paying: "Opening payment…", cancel: "Back",
    mine: "My consultations", open: "Open",
    st_waiting: "Waiting for astrologer", st_active: "Chat open", st_closed: "Finished", st_refund_requested: "Refund requested", st_refunded: "Refunded",
    waitText: "Your question has been sent. An astrologer usually joins within 1–2 hours. You can close this page — your chat stays here.",
    refundAsk: "No one joined yet — ask for a full refund", refundDone: "Refund requested. Money returns to your account in 5–7 days.",
    left: "{m} min left", closedText: "This consultation has ended. How was it?", thanks: "Thank you for rating.",
    write: "Type your message", send: "Send", hidden: "Phone numbers and links are hidden to keep you safe.",
    you: "You", login: "Please sign in to talk to an astrologer.", back: "← All astrologers",
  },
  hi: {
    title: "ज्योतिषी से बात करें",
    sub: "अपना प्रश्न एक असली, जाँचे-परखे वैदिक ज्योतिषी से पूछें। वे आपकी कुंडली देखते हैं, आपको समझाना नहीं पड़ेगा।",
    how: ["अपना प्रश्न लिखें", "एक बार {p} दें (UPI, कार्ड)", "ज्योतिषी {m} मिनट आपसे चैट करेंगे"],
    promise: "हमारे ज्योतिषियों का वादा: डर नहीं, पक्की भविष्यवाणी का दावा नहीं, रत्न या महँगी पूजा का दबाव नहीं।",
    none: "हमारे पहले ज्योतिषी अभी जुड़ रहे हैं। कुछ दिनों में फिर देखें।",
    joinAstro: "क्या आप ज्योतिषी हैं? VedSanga से जुड़ें",
    online: "अभी ऑनलाइन", years: "{n} वर्ष का अनुभव", langs: "भाषाएँ",
    ask: "{n} से पूछें", askAny: "पहले उपलब्ध ज्योतिषी से पूछें",
    qLabel: "आपका प्रश्न", qHelp: "वैसे ही लिखें जैसे परिवार के पंडित जी से कहते। जैसे: मेरी शादी में देरी हो रही है — अच्छा समय कब है?",
    noBirth: "आपका जन्म विवरण अभी सेव नहीं है। पहले ज्योतिष में जोड़ें, ताकि ज्योतिषी आपकी कुंडली पढ़ सकें।",
    pay: "{p} दें और प्रश्न भेजें", paying: "भुगतान खुल रहा है…", cancel: "वापस",
    mine: "मेरी बातचीत", open: "खोलें",
    st_waiting: "ज्योतिषी का इंतज़ार", st_active: "चैट चालू", st_closed: "पूरी हुई", st_refund_requested: "रिफ़ंड माँगा गया", st_refunded: "रिफ़ंड हो गया",
    waitText: "आपका प्रश्न भेज दिया गया है। आमतौर पर 1–2 घंटे में ज्योतिषी जुड़ते हैं। आप यह पेज बंद कर सकते हैं — चैट यहीं रहेगी।",
    refundAsk: "अभी तक कोई नहीं जुड़ा — पूरा रिफ़ंड माँगें", refundDone: "रिफ़ंड माँगा गया। पैसा 5–7 दिन में आपके खाते में लौटेगा।",
    left: "{m} मिनट बाकी", closedText: "यह बातचीत पूरी हुई। कैसी रही?", thanks: "रेटिंग के लिए धन्यवाद।",
    write: "अपना संदेश लिखें", send: "भेजें", hidden: "आपकी सुरक्षा के लिए फ़ोन नंबर और लिंक छिपाए जाते हैं।",
    you: "आप", login: "ज्योतिषी से बात करने के लिए साइन इन करें।", back: "← सभी ज्योतिषी",
  },
  te: {
    title: "జ్యోతిష్యులతో మాట్లాడండి",
    sub: "మీ ప్రశ్నను నిజమైన, పరిశీలించిన వైదిక జ్యోతిష్యులను అడగండి. వారు మీ జాతకం చూస్తారు, మీరు వివరించాల్సిన పని లేదు.",
    how: ["మీ ప్రశ్న రాయండి", "ఒకసారి {p} చెల్లించండి (UPI, కార్డ్)", "జ్యోతిష్యులు {m} నిమిషాలు మీతో చాట్ చేస్తారు"],
    promise: "మా జ్యోతిష్యుల వాగ్దానం: భయపెట్టరు, ఖచ్చితమైన జోస్యం అని చెప్పరు, రత్నాలు లేదా ఖరీదైన పూజల ఒత్తిడి ఉండదు.",
    none: "మా మొదటి జ్యోతిష్యులు ఇప్పుడు చేరుతున్నారు. కొన్ని రోజుల్లో మళ్లీ చూడండి.",
    joinAstro: "మీరు జ్యోతిష్యులా? VedSangaలో చేరండి",
    online: "ఇప్పుడు ఆన్‌లైన్", years: "{n} సంవత్సరాల అనుభవం", langs: "భాషలు",
    ask: "{n} గారిని అడగండి", askAny: "మొదట అందుబాటులో ఉన్న జ్యోతిష్యులను అడగండి",
    qLabel: "మీ ప్రశ్న", qHelp: "ఇంటి పంతులు గారికి చెప్పినట్లే రాయండి. ఉదా: నా పెళ్లి ఆలస్యం అవుతోంది — మంచి సమయం ఎప్పుడు?",
    noBirth: "మీ జనన వివరాలు ఇంకా సేవ్ కాలేదు. ముందు జ్యోతిష్యంలో జోడించండి, అప్పుడు జ్యోతిష్యులు మీ జాతకం చదవగలరు.",
    pay: "{p} చెల్లించి ప్రశ్న పంపండి", paying: "చెల్లింపు తెరుస్తోంది…", cancel: "వెనక్కి",
    mine: "నా సంప్రదింపులు", open: "తెరవండి",
    st_waiting: "జ్యోతిష్యుల కోసం వేచి ఉంది", st_active: "చాట్ తెరిచి ఉంది", st_closed: "పూర్తయింది", st_refund_requested: "రీఫండ్ అడిగారు", st_refunded: "రీఫండ్ అయింది",
    waitText: "మీ ప్రశ్న పంపబడింది. సాధారణంగా 1–2 గంటల్లో జ్యోతిష్యులు చేరతారు. ఈ పేజీ మూసేయవచ్చు — చాట్ ఇక్కడే ఉంటుంది.",
    refundAsk: "ఇంకా ఎవరూ చేరలేదు — పూర్తి రీఫండ్ అడగండి", refundDone: "రీఫండ్ అడిగారు. డబ్బు 5–7 రోజుల్లో మీ ఖాతాకు తిరిగి వస్తుంది.",
    left: "{m} నిమిషాలు మిగిలాయి", closedText: "ఈ సంప్రదింపు పూర్తయింది. ఎలా ఉంది?", thanks: "రేటింగ్ ఇచ్చినందుకు ధన్యవాదాలు.",
    write: "మీ సందేశం రాయండి", send: "పంపండి", hidden: "మీ భద్రత కోసం ఫోన్ నంబర్లు, లింకులు దాచబడతాయి.",
    you: "మీరు", login: "జ్యోతిష్యులతో మాట్లాడటానికి సైన్ ఇన్ చేయండి.", back: "← అందరు జ్యోతిష్యులు",
  },
};

const card = { background: C.card, border: `1.5px solid ${C.border}`, borderRadius: 16, padding: 20, marginBottom: 16 };
const LANG_NAMES = { te: "తెలుగు", hi: "हिन्दी", en: "English", ta: "தமிழ்", kn: "ಕನ್ನಡ", mr: "मराठी" };

function Avatar({ a, size = 64 }) {
  return a.photo_url
    ? <img src={a.photo_url} alt="" style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", flex: "none" }} />
    : <div style={{ width: size, height: size, borderRadius: "50%", background: C.warm, display: "flex", alignItems: "center",
        justifyContent: "center", fontSize: size / 2.4, fontWeight: 800, color: C.accentDark, flex: "none" }}>{(a.name || "?")[0]}</div>;
}

export default function ConsultPage({ user, lang = "en", initialConsult = null }) {
  const t = T[lang] || T.en;
  const [list, setList] = useState(null);
  const [mine, setMine] = useState([]);
  const [asking, setAsking] = useState(null);      // astrologer object or "any"
  const [openId, setOpenId] = useState(initialConsult);

  const load = useCallback(() => {
    getJson("/astrologers").then(setList, () => setList({ astrologers: [], price_inr: 199, minutes: 15 }));
    if (user?.id) getJson(`/consults/mine/${encodeURIComponent(user.id)}`).then((d) => setMine(d.consults || []), () => {});
  }, [user?.id]);
  useEffect(load, [load]);

  if (!user?.id) return <Wrap><p style={{ fontSize: 18 }}>{t.login}</p></Wrap>;
  if (openId) return <Wrap><ConsultChat t={t} user={user} id={openId} onBack={() => { setOpenId(null); load(); }} /></Wrap>;
  if (asking) {
    return <Wrap><AskForm t={t} user={user} target={asking} price={list?.price_inr || 199}
      onCancel={() => setAsking(null)} onDone={(cid) => { setAsking(null); setOpenId(cid); }} /></Wrap>;
  }

  const p = `₹${list?.price_inr || 199}`;
  const astros = list?.astrologers || [];
  return (
    <Wrap>
      <h1 style={{ fontSize: 30, fontWeight: 800, margin: "0 0 8px", color: C.text }}>{t.title}</h1>
      <p style={{ fontSize: 18, lineHeight: 1.55, color: C.dim, margin: "0 0 20px" }}>{t.sub}</p>

      {mine.length > 0 && (
        <div style={card}>
          <h2 style={{ fontSize: 22, margin: "0 0 12px" }}>{t.mine}</h2>
          {mine.map((x) => (
            <div key={x.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderTop: `1px solid ${C.border}` }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 17, color: C.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{x.question}</div>
                <div style={{ fontSize: 15, color: C.dim }}>{t[`st_${x.status}`] || x.status}{x.astrologer ? ` · ${x.astrologer.name}` : ""}</div>
              </div>
              <button onClick={() => setOpenId(x.id)} style={{ ...btn(C.accent), width: "auto", minHeight: 44 }}>{t.open}</button>
            </div>
          ))}
        </div>
      )}

      <div style={{ ...card, background: C.warm }}>
        <ol style={{ margin: 0, paddingLeft: 22, fontSize: 18, lineHeight: 1.7, color: C.text }}>
          {t.how.map((h, i) => <li key={i}>{fill(h, { p, m: list?.minutes || 15 })}</li>)}
        </ol>
        <p style={{ fontSize: 16, color: C.dim, margin: "12px 0 0" }}>{t.promise}</p>
      </div>

      {list && astros.length === 0 && (
        <div style={card}>
          <p style={{ fontSize: 18, margin: "0 0 12px" }}>{t.none}</p>
          <a href="/?page=astrologer" style={{ fontSize: 17, color: C.accentDark, fontWeight: 700 }}>{t.joinAstro}</a>
        </div>
      )}

      {astros.length > 0 && (
        <button onClick={() => setAsking("any")} style={{ ...btn(C.accent), maxWidth: 520, marginBottom: 20 }}>{t.askAny} · {p}</button>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 16 }}>
        {astros.map((a) => (
          <div key={a.id} style={{ ...card, marginBottom: 0, display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
              <Avatar a={a} />
              <div>
                <div style={{ fontSize: 20, fontWeight: 800, color: C.text }}>{a.name}</div>
                {a.online && <div style={{ fontSize: 15, fontWeight: 700, color: C.wa }}>● {t.online}</div>}
                {a.years ? <div style={{ fontSize: 15, color: C.dim }}>{fill(t.years, { n: a.years })}</div> : null}
              </div>
            </div>
            {a.languages?.length ? <div style={{ fontSize: 16, color: C.text }}>{t.langs}: {a.languages.map((l) => LANG_NAMES[l] || l).join(", ")}</div> : null}
            {a.specialties?.length ? <div style={{ fontSize: 16, color: C.text }}>{a.specialties.join(" · ")}</div> : null}
            {a.bio ? <p style={{ fontSize: 16, lineHeight: 1.5, color: C.dim, margin: 0 }}>{a.bio}</p> : null}
            <button onClick={() => setAsking(a)} style={{ ...btn(C.accent), marginTop: "auto" }}>{fill(t.ask, { n: a.name.split(" ")[0] })} · {p}</button>
          </div>
        ))}
      </div>
    </Wrap>
  );
}

function Wrap({ children }) {
  return <div style={{ maxWidth: 980, margin: "0 auto", padding: "24px 16px 60px", fontFamily: FONT, color: C.text }}>{children}</div>;
}

function AskForm({ t, user, target, price, onCancel, onDone }) {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [hasBirth, setHasBirth] = useState(true);
  useEffect(() => {
    getJson(`/user/birthdate/${encodeURIComponent(user.id)}`).then((d) => setHasBirth(!!d.dob), () => {});
  }, [user.id]);
  const ref = new URLSearchParams(window.location.search).get("ref") || "";

  const submit = async () => {
    setErr("");
    if (q.trim().length < 10) return setErr(t.qHelp);
    setBusy(true);
    try {
      const oid = await payOrder({
        user, kind: "consult", description: "Astrologer consultation",
        inputs: { question: q.trim(), astrologer_id: target === "any" ? "any" : target.id, ref },
      });
      if (oid) onDone(`c_${oid.slice(2)}`);
    } catch (e) {
      setErr(e.message);
    }
    setBusy(false);
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <button onClick={onCancel} style={{ background: "none", border: "none", fontSize: 17, color: C.accentDark, cursor: "pointer", padding: 0, marginBottom: 16 }}>{t.back}</button>
      <h1 style={{ fontSize: 26, fontWeight: 800, margin: "0 0 16px" }}>{target === "any" ? t.askAny : fill(t.ask, { n: target.name })}</h1>
      {!hasBirth && <p style={{ ...card, background: "#FFF1E0", fontSize: 17 }}>{t.noBirth}</p>}
      <label style={label} htmlFor="consult-q">{t.qLabel}</label>
      <p style={{ fontSize: 16, color: C.dim, margin: "0 0 8px" }}>{t.qHelp}</p>
      <textarea id="consult-q" value={q} onChange={(e) => setQ(e.target.value)} rows={5} maxLength={600}
        style={{ width: "100%", boxSizing: "border-box", fontSize: 18, padding: 14, borderRadius: 12, border: `1.5px solid ${C.border}`, fontFamily: FONT, lineHeight: 1.5 }} />
      <p style={{ fontSize: 15, color: C.dim }}>{t.hidden}</p>
      <button onClick={submit} disabled={busy} style={{ ...btn(C.accent), opacity: busy ? 0.7 : 1 }}>{busy ? t.paying : fill(t.pay, { p: `₹${price}` })}</button>
      {err && <p style={{ color: "#B42318", fontSize: 17 }}>{err}</p>}
    </div>
  );
}

export function ConsultChat({ t, user, id, onBack }) {
  const [c, setC] = useState(null);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [note, setNote] = useState("");
  const last = useRef(0);
  const endRef = useRef(null);

  const poll = useCallback(() => {
    getJson(`/consult/${id}?user_id=${encodeURIComponent(user.id)}&after=${last.current}`).then((d) => {
      setC(d);
      if (d.messages?.length) {
        last.current = d.messages[d.messages.length - 1].id;
        setMsgs((m) => [...m, ...d.messages]);
      }
    }, (e) => setNote(e.message));
  }, [id, user.id]);

  useEffect(() => {
    poll();
    const h = setInterval(poll, 5000);
    return () => clearInterval(h);
  }, [poll]);
  useEffect(() => { endRef.current?.scrollIntoView({ block: "end" }); }, [msgs.length]);

  const send = async () => {
    const body = text.trim();
    if (!body) return;
    setText("");
    try { await postJson("/consult/message", { user_id: user.id, consult_id: id, body }); poll(); }
    catch (e) { setNote(e.message); setText(body); }
  };
  const refund = async () => {
    try { await postJson("/consult/refund", { user_id: user.id, consult_id: id }); setNote(t.refundDone); poll(); }
    catch (e) { setNote(e.message); }
  };
  const rate = async (s) => {
    try { await postJson("/consult/rate", { user_id: user.id, consult_id: id, stars: s }); setNote(t.thanks); poll(); }
    catch (e) { setNote(e.message); }
  };

  const minsLeft = c?.ends_at ? Math.max(0, Math.ceil((new Date(c.ends_at) - new Date()) / 60000)) : null;
  return (
    <div style={{ maxWidth: 680 }}>
      <button onClick={onBack} style={{ background: "none", border: "none", fontSize: 17, color: C.accentDark, cursor: "pointer", padding: 0, marginBottom: 16 }}>{t.back}</button>
      {c?.astrologer && (
        <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12 }}>
          <Avatar a={c.astrologer} size={52} />
          <div style={{ fontSize: 20, fontWeight: 800 }}>{c.astrologer.name}</div>
        </div>
      )}
      {c && (
        <div style={{ ...card, background: C.warm, padding: 14, fontSize: 17 }}>
          <b>{t[`st_${c.status}`] || c.status}</b>
          {c.status === "active" && minsLeft !== null ? ` · ${fill(t.left, { m: minsLeft })}` : ""}
          {c.status === "waiting" && <div style={{ marginTop: 6, color: C.dim }}>{t.waitText}</div>}
          {c.can_refund && <button onClick={refund} style={{ ...btn("#fff", C.accentDark), border: `1.5px solid ${C.accent}`, marginTop: 10 }}>{t.refundAsk}</button>}
        </div>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: 10, margin: "12px 0" }}>
        {msgs.map((m) => (
          <div key={m.id} style={{
            alignSelf: m.sender === "user" ? "flex-end" : "flex-start", maxWidth: "85%", whiteSpace: "pre-wrap",
            background: m.sender === "user" ? "#FFE7CC" : C.card, border: `1.5px solid ${C.border}`, borderRadius: 14,
            padding: "10px 14px", fontSize: 18, lineHeight: 1.5, color: C.text,
          }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: C.dim, marginBottom: 2 }}>{m.sender === "user" ? t.you : c?.astrologer?.name}</div>
            {m.body}
          </div>
        ))}
        <div ref={endRef} />
      </div>
      {c?.can_send && (
        <div style={{ display: "flex", gap: 8 }}>
          <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
            placeholder={t.write} aria-label={t.write} maxLength={1000}
            style={{ flex: 1, minHeight: 52, fontSize: 18, padding: "0 14px", borderRadius: 12, border: `1.5px solid ${C.border}`, fontFamily: FONT }} />
          <button onClick={send} style={{ ...btn(C.accent), width: "auto" }}>{t.send}</button>
        </div>
      )}
      {c?.status === "closed" && !c.rating && (
        <div style={card}>
          <p style={{ fontSize: 18, margin: "0 0 10px" }}>{t.closedText}</p>
          <div style={{ display: "flex", gap: 8 }}>
            {[1, 2, 3, 4, 5].map((s) => (
              <button key={s} onClick={() => rate(s)} aria-label={`${s}`} style={{ ...btn(C.warm, C.accentDark), width: 56, border: `1.5px solid ${C.border}` }}>{s}★</button>
            ))}
          </div>
        </div>
      )}
      {note && <p style={{ fontSize: 17, color: C.dim }}>{note}</p>}
    </div>
  );
}
